import React, { useEffect, FC } from 'react'
import { css } from '@emotion/core'

import Button from 'components/common/atoms/Button'
import { FBLogin, loadSDKAsync, windowFBInit } from 'utils/fbSdk'
import FBIcon from 'svgs/facebook-icon.svg'
import LoadingIndicator from 'svgs/small-loading.svg'

type FBLoginButtonProps = {
  buttonText?: string
  isLoading?: boolean
  disabled?: boolean
  loginCb: (response: fb.StatusResponse) => void
}

const FBLoginButton: FC<FBLoginButtonProps> = ({ loginCb, buttonText, isLoading, disabled }) => {
  const initFB = () => {
    loadSDKAsync()
    windowFBInit()
  }
  const handleLogin = () => {
    FBLogin(loginCb)
  }

  useEffect(() => {
    initFB()
  }, [])

  return (
    <Button
      type="button"
      onClick={handleLogin}
      css={css`
        background-color: ${isLoading || disabled ? '#6d8cb5' : '#386095'};
        color: #fff;

        display: flex;
        justify-content: center;
        align-items: center;

        @media screen and (max-width: 576px) {
          font-size: 0.875rem;
        }
      `}
      isDisabled={isLoading || disabled}
      isFullWidth
    >
      {isLoading ? (
        <LoadingIndicator
          css={css`
            height: 24px;
            fill: #fff;
          `}
        />
      ) : (
        <>
          <FBIcon
            css={css`
              fill: #fff;
              width: 16px;
              height: 16px;
              margin-right: 8px;
            `}
          />
          {buttonText || 'Continue with Facebook'}
        </>
      )}
    </Button>
  )
}

export default FBLoginButton
